var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehiculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.74 12.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-1",
    d: "M5.29,10.73A2.46,2.46,0,1,0,7.74,8.05a2.58,2.58,0,0,0-2.45,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-1",
    d: "M29.17,10.73a2.47,2.47,0,1,0,2.46-2.68,2.58,2.58,0,0,0-2.46,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-1",
    d: "M0,7.73C.12,6.37,0,4.6.64,4.35c1.42-.52,3.79-2.26,4.64-2.58C10.61-.21,17.71-.29,20.35.39c3.89,1,6.24,2.51,8.39,3.13,3,.88,4.07.67,7.55,2.23a2.23,2.23,0,0,1,1.36,1.37,3.69,3.69,0,0,1-.3,2.47c-.05.42.16.42.27.42s.19,1.2-.35,1.43h0c-.5.26-1,.5-1.53.71a4.23,4.23,0,0,1-.79-.08,4,4,0,0,0,.21-1.33,4,4,0,0,0-1-2.8,3.31,3.31,0,0,0-4.69-.38,2.28,2.28,0,0,0-.38.38,4.06,4.06,0,0,0-1,2.8,7.73,7.73,0,0,0,.12,1.36c-4.66,0-14-.2-17.16,0a4,4,0,0,0,.22-1.36A3.9,3.9,0,0,0,9.52,7.41,3.29,3.29,0,0,0,6,7.41a3.92,3.92,0,0,0-1.76,3.33,4.11,4.11,0,0,0,.07.78,16.18,16.18,0,0,1-3-.29A5.57,5.57,0,0,1,0,7.73ZM24.46,4.35a3.12,3.12,0,0,0,1.76-.48c-.19-.3-3.4-2.71-8.92-3,.12.79.38,2.34.48,3.3,2.95.13,5.95.24,6.68.21ZM6.34,2.29h0A3.58,3.58,0,0,0,6.9,3c.83.73,2.55.71,5.47.9.88.06,2.22.13,3.7.2L16.23.8A29.74,29.74,0,0,0,6.37,2.26c-.09-.06,0,0,0,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiculo);
export default __webpack_public_path__ + "static/media/vehiculo.958003cb1a30026f76ed43dad556bc59.svg";
export { ForwardRef as ReactComponent };